import { render } from "./StepsMain.vue?vue&type=template&id=4da86a28&scoped=true"
import script from "./StepsMain.vue?vue&type=script&lang=js"
export * from "./StepsMain.vue?vue&type=script&lang=js"

import "./StepsMain.vue?vue&type=style&index=0&id=4da86a28&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da86a28"]])

export default __exports__